/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { messages } from './ManageMemoryEditsSubscreen.messages';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.xlarge'),
		overflow: 'hidden',
	},
	centeredContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '1 1 0%',
		minHeight: '200px',
		paddingBlock: token('space.400'),
		paddingInline: token('space.300'),
		textAlign: 'center',
	},
});

export const LoadingState = (): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={styles.container} space="space.0">
			<Box xcss={styles.centeredContent}>
				<Spinner label={formatMessage(messages.loadingLabel)} size="medium" />
			</Box>
		</Stack>
	);
};
